import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";

var Stars = function Stars(props) {
  var starsArray = [];

  for (var i = 1; i <= 5; i++) {
    i <= props.stars ? starsArray.push( /*#__PURE__*/_jsx("i", {
      className: "fa ".concat(props.size ? "fa-" + props.size : "", " fa-star ").concat(props.color ? props.color : "text-warning")
    }, i)) : starsArray.push( /*#__PURE__*/_jsx("i", {
      className: "fa fa-star ".concat(props.size ? "fa-" + props.size : "", " text-gray-300")
    }, i));
  }

  return starsArray;
};

export default Stars;